import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkTextArea } from './uitk-textarea.esm.js';
var UitkChatTextArea = function (props) {
  var remaining = __rest(props, []);
  return React.createElement(UitkTextArea, __assign({
    className: "uitk-field-textarea-with-chat"
  }, remaining, {
    hasVisibleLabel: false
  }));
};
UitkChatTextArea.displayName = 'UitkChatTextArea';
export { UitkChatTextArea };